import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { NavbarComponent } from './navbar/navbar.component';

@Component({
  selector: 'flex-privacy-policy-header',
  imports: [LanguageSelectorComponent, NavbarComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {}
